import { h, Component } from 'preact';
import Router, { route } from 'preact-router';

import {
	HOME,
	PRICING,
	REQUESTDEMO,
	PRIVACY
} from '../config/constants';

import Home from '../routes/home';
import Pricing from '../routes/pricing';
import RequestDemo from '../routes/demo';
import Privacy from '../routes/privacy';

export default class App extends Component {
	
	handleRoute = e => {
		this.currentUrl = e.url;
	}; 

	render({ history }) {
		return (
			<div id="app">
				<Router history={history} onChange={this.handleRoute}>
					<Home 
						path={HOME} 
					/>

					<Pricing
						path={PRICING}
					/>

					<RequestDemo 
						path={REQUESTDEMO}
					/>

					<Privacy
						path='/privacy'
					/>
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js